import AddressAutoComplete from "../../Components/AddressAutoComplete";
import {Button, Card, Col, Form, Input, InputNumber, Row, message} from "antd";
import {ArrowLeftOutlined} from "@ant-design/icons";
import MarketplaceHeader from "../../Components/MarketplaceHeader";
import React, {useState} from "react";
import api from "../../api";

export default function Subscribe() {
    const [location, setLocation] = useState({});

    const [form] = Form.useForm();

    const onSubscribe = () => {

        const data = {
            name: form.getFieldValue('name'),
            email: form.getFieldValue('email'),
            location: location?.name,
            lat: location?.lat,
            lng: location?.lng,
            radius: form.getFieldValue('max_distance') || 5
        };
        api.subscribeToAlerts(data).then(() => {
            message.success("Je bent succesvol ingeschreven voor Oogst Alerts! Je ontvangt vanaf nu meldingen zodra er iets nieuws beschikbaar is in jouw buurt.");
        })
    }

    return (
        <div className="subscribe-page">
            <Row>
                <Col span={24}>
                    <MarketplaceHeader/>
                </Col>
            </Row>
            <Row justify={"center"}>
                <Col md={8}>
                    <Button type={"link"} className={"mar-b-1"}>
                        <a href="/markt"><ArrowLeftOutlined/> Terug naar overzicht</a>
                    </Button>
                    <Card style={{background: 'white'}}>
                        <h1>Inschrijven voor Oogst Alerts!</h1>
                        <p>Krijg een melding zodra er iets nieuws beschikbaar is in jouw buurt.</p>
                        <Form layout={"vertical"} form={form}>
                            <Form.Item
                                name={"name"}
                                label={"Naam"}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Vul je naam in'
                                    }
                                ]}>
                                <Input/>
                            </Form.Item>
                            <Form.Item rules={[
                                {
                                    required: true,
                                    type: 'email',
                                    message: 'Vul een geldig e-mailadres in'
                                }
                            ]} name="email" label={"E-mailadres"}>
                                <Input type={"email"}/>
                            </Form.Item>
                            <Form.Item name="location" label={"Adres"}>
                                {location && (
                                    <>
                                        <AddressAutoComplete value={location.name} onChange={(v) => {
                                            setLocation({
                                                ...location,
                                                name: v
                                            })
                                        }} onSelect={(e) => {
                                            if (!e) {
                                                return
                                            }
                                            setLocation({
                                                lat: e.geometry.location.lat(),
                                                lng: e.geometry.location.lng(),
                                                name: e.formatted_address || e.name
                                            })
                                        }}/>
                                    </>
                                )}

                            </Form.Item>
                            <Form.Item name={"radius"} rules={[
                                {
                                    required: true,
                                    message: 'Vul een maximale afstand in'
                                }
                            ]} label={"Maximale afstand (km)"}>
                                <InputNumber/>
                            </Form.Item>
                            <Form.Item>
                                <Button size={"large"} onClick={onSubscribe} type={"primary"}>Inschrijven</Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}